function animatedScrollObserver() {
    return new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                document.getElementById("background_style").style.transition = "all 1s ease-out"
                document.getElementById("background_style").style.backgroundColor = "white";

                document.getElementById("b_1").style.transition = "all 1s ease-out"
                document.getElementById("b_1").style.opacity = "0";

                document.getElementById("b_0").style.transition = "all 1s ease-out"
                document.getElementById("b_0").style.opacity = "0";

                // document.getElementById("b_2").style.transition = "all 1s ease-out"
                // document.getElementById("b_2").style.opacity = "0";
                // Use the custom argument as needed
                // console.log('Custom argument:', customArg);
                
                // observer.unobserve(entry.target);
            }
        });
    });
}

export default{
    bind(el){
        // el.classList.add(binding.value.before_enter);
        animatedScrollObserver().observe(el);
    }
}